import React, { useEffect } from "react";
import { useTheme } from "next-themes";
import { Button } from "./ui/button";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const isDark = theme === "dark";
  const toggle = () => setTheme(isDark ? "light" : "dark");

  // Persist to localStorage explicitly to ensure we remember user choice across visits
  useEffect(() => {
    try {
      const key = "rl_theme_v1";
      if (theme === "system") {
        if (resolvedTheme === "dark" || resolvedTheme === "light") {
          localStorage.setItem(key, resolvedTheme);
        }
      } else if (theme === "dark" || theme === "light") {
        localStorage.setItem(key, theme);
      }
    } catch (_) {}
  }, [theme, resolvedTheme]);

  return (
    <Button data-tour-id="nav-theme" variant="ghost" size="icon" onClick={toggle} aria-label="Toggle theme">
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </Button>
  );
}